enum ETextAreaVariant {
    Default = "default",
    LightGray = "lightGray",
    LightBlue = "lightBlue",
    Error = "error",
    Transparent = "transparent"
}

enum ETextAreaScrollbarVariant {
    Transparent = "noScrollbar",
    Thin = "thin"
}

enum ETextAreaBorderWidth {
    Tiny = "tiny",
    Medium = "medium"
}

export { ETextAreaVariant, ETextAreaScrollbarVariant, ETextAreaBorderWidth }
